import { render, staticRenderFns } from "./MrzHeading.vue?vue&type=template&id=07164b2c&scoped=true"
import script from "./MrzHeading.vue?vue&type=script&lang=js"
export * from "./MrzHeading.vue?vue&type=script&lang=js"
import style0 from "./MrzHeading.vue?vue&type=style&index=0&id=07164b2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07164b2c",
  null
  
)

export default component.exports